import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "@/i18n";

export default function LangToggle({ className = "" }) {
  const loc = useLocation();
  const navigate = useNavigate();
  const isEn = loc.pathname === "/en" || loc.pathname.startsWith("/en/");

  const switchTo = (lang) => {
    if ((lang === "en") === isEn) return;
    let path = loc.pathname;
    if (lang === "en") path = "/en" + (path === "/" ? "" : path);
    else path = path.replace(/^\/en/, "") || "/";
    localStorage.setItem("lattice_lang", lang);
    i18n.changeLanguage(lang);
    navigate(path + loc.search);
  };

  return (
    <div className={`inline-flex items-center border border-[#262626] bg-[#0d0d0d] font-mono text-[11px] uppercase tracking-wider ${className}`} data-testid="lang-toggle">
      <button
        onClick={() => switchTo("it")}
        data-testid="lang-it"
        className={`px-2.5 py-1.5 transition-colors ${!isEn ? "lp-b text-white" : "text-[#a3a3a3] hover:text-white"}`}
      >IT</button>
      <button
        onClick={() => switchTo("en")}
        data-testid="lang-en"
        className={`px-2.5 py-1.5 transition-colors ${isEn ? "lp-b text-white" : "text-[#a3a3a3] hover:text-white"}`}
      >EN</button>
    </div>
  );
}
